import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["v1-chip", { 'v1-chip--selected': _ctx.selected }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select')))
  }, _toDisplayString(_ctx.label), 3))
}